(function () {
  const root = document.querySelector('[data-b2b-docs]');
  if (!root) return;

  const progress = root.querySelector('[data-b2b-docs-progress]');
  const navLinks = root.querySelectorAll('[data-b2b-docs-nav] a[href^="#"]');
  const headings = root.querySelectorAll('.b2b-docs__heading, .b2b-docs__content h2[id]');

  const updateProgress = () => {
    if (!progress) return;
    const scrollTop = window.scrollY;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    const pct = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
    progress.style.width = `${Math.min(100, Math.max(0, pct))}%`;
  };

  const setActiveNav = (id) => {
    navLinks.forEach((link) => {
      const href = link.getAttribute('href');
      link.classList.toggle('is-active', href === `#${id}`);
    });
  };

  const onScroll = () => {
    updateProgress();

    let currentId = '';
    headings.forEach((heading) => {
      const rect = heading.getBoundingClientRect();
      if (rect.top <= 120) {
        currentId = heading.id;
      }
    });

    if (currentId) {
      setActiveNav(currentId);
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
